export default [
  { code: '{{portfolio_cash_allocation}}', explanation: 'The cash allocation of the portfolio' },
  { code: '{{portfolio_fixed_income_allocation}}', explanation: 'The fixed income allocation of the portfolio' },
  { code: '{{portfolio_equity_allocation}}', explanation: 'The equity allocation of the portfolio' },
  { code: '{{portfolio_hedge_fund_allocation}}', explanation: 'The hedge fund allocation of the portfolio' },
  { code: '{{portfolio_other_assets_allocation}}', explanation: 'The other assets allocation of the portfolio' },
];
